export default __webpack_public_path__ + "static/media/livingroom.78b58b6c.webp";